import { RouteConfig } from 'vue-router'

import intelligentClassroomIconActive from '../assets/images/icon_menu_intelligent_classroom_active@2x.png'
import intelligentClassroomIconInactive from '../assets/images/icon_menu_intelligent_classroom_inactive@2x.png'

const Layout = () => import('../views/Layout.vue')
const Landing = () => import('../views/intelligent-classroom/Landing.vue')
const ClassProcessing = () => import('../views/intelligent-classroom/ClassProcessingPage.vue')
const ClassStageInfo = () => import('../views/intelligent-classroom/ClassStageInfoPage.vue')
const Detail = () => import('../views/intelligent-classroom/ContestDetail.vue')
const Screen = () => import('../views/intelligent-screen/Index.vue')
const Upload = () => import('../views/intelligent-classroom/ClassSportUploadPage.vue')
const Analyze = () => import('../views/intelligent-classroom/ClassSportAnalyPage.vue')

export const landingRoute: RouteConfig = {
  path: 'landing',
  name: 'intelligent_classroom_landing',
  component: Landing,
  meta: {
    title: '课堂报告',
    showMenu: true,
  },
}

export const contestDetailRoute: RouteConfig = {
  path: 'detail',
  name: 'detail_contest',
  component: Detail,
  props: (route) => ({
    ...route.query,
    ...route.params,
  }),
  meta: {
    title: '智慧体育课堂',
  },
}

export const screenRoute: RouteConfig = {
  path: '/intelligent-screen',
  name: 'intelligent_screen',
  component: Screen,
  props: (route) => ({
    ...route.query,
    ...route.params,
  }),
  meta: {
    title: '智慧体育课堂-投屏',
  },
}
export const uploadRoute: RouteConfig = {
  path: '/intelligent-sport-upload',
  name: 'intelligent_sport_upload',
  component: Upload,
  props: (route) => ({
    ...route.query,
    ...route.params,
  }),
  meta: {
    title: '选择视频素材',
  },
}
export const analyzeRoute: RouteConfig = {
  path: '/intelligent-sport-analyze',
  name: 'intelligent_sport_analyze',
  component: Analyze,
  props: (route) => ({
    ...route.query,
    ...route.params,
  }),
  meta: {
    title: '智能运动分析',
  },
}

export default [
  {
    path: '/intelligent-classroom',
    name: 'intelligent_classroom',
    component: Layout,
    meta: {
      title: '智慧体育课堂',
      icon: intelligentClassroomIconInactive,
      iconActive: intelligentClassroomIconActive,
      showMenu: true,
    },
    children: [landingRoute, contestDetailRoute],
  },
  {
    path: '/intelligent-classroom-processing',
    name: 'intelligent_classroom_processing',
    component: ClassProcessing,
    props: (route: any) => ({
      ...route.query,
      ...route.params,
    }),
    meta: {
      title: '上课中',
    },
  },
  {
    path: '/intelligent-classroom-classinfo',
    name: 'intelligent_classroom_classinfo',
    component: ClassStageInfo,
    props: (route: any) => ({
      ...route.query,
      ...route.params,
    }),
    meta: {
      title: '上课中',
    },
  },
  screenRoute,
  uploadRoute,
  analyzeRoute,
]
